import { render, staticRenderFns } from "./ui-alert.vue?vue&type=template&id=77f7e22e&"
import script from "./ui-alert.vue?vue&type=script&lang=js&"
export * from "./ui-alert.vue?vue&type=script&lang=js&"
import style0 from "./ui-alert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f7e22e')) {
      api.createRecord('77f7e22e', component.options)
    } else {
      api.reload('77f7e22e', component.options)
    }
    module.hot.accept("./ui-alert.vue?vue&type=template&id=77f7e22e&", function () {
      api.rerender('77f7e22e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/ui-alert.vue"
export default component.exports